<template>
  <div class="element-box">
    <div v-if="travelExpenses.status === 'draft' || travelExpenses.status === 'modification'"
         class="mb-4" style="float: right">

      <CreateButton
          :label="$t('general.button.submit')"
          @click.prevent="submitForApproval(travelExpenses.id)">
      </CreateButton>
    </div>

    <div class="table-responsive mt-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>{{ $t('general.date') }}</th>
          <th>{{ $t('general.start_location') }}</th>
          <th>{{ $t('general.end_location') }}</th>
          <th class="text-right">{{ $t('general.kilometer') }}</th>
          <th>{{ $t('general.reason') }}</th>
          <th v-if="travelExpenses.status === 'draft' || travelExpenses.status === 'modification'"
              class="text-right" style="padding-right: 40px;">{{ $t('general.actions') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.date }}</td>
          <td>{{ item.startLocation }}</td>
          <td>{{ item.endLocation }}</td>
          <td class="text-right">{{ item.distance }}</td>
          <td>{{ item.reason }}</td>
          <td v-if=" travelExpenses.status === 'draft' || travelExpenses.status === 'modification'"
              class="text-right" style="min-width: 130px;">
            <button class="btn btn-primary" @click="getItemData(item)">
              <i class="os-icon os-icon-edit"></i>
            </button>
            <button class="btn btn-danger ml-2" @click="deleteItem(item?.id)">
              <i class="os-icon os-icon-trash"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

<!--    <div class="d-flex justify-content-end mt-3" style="border-top: 1px solid black">-->
<!--      <div style="width: 160px; font-size: 16px; margin-top: 15px;">Gesamt KM:</div>-->
<!--      <div class="text-right" style="width: 150px; font-size: 16px; margin-top: 15px;">-->
<!--        {{ travelExpenses.distance }}-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="d-flex justify-content-end">-->
<!--      <div style="width: 160px; font-size: 16px">Preis pro Kilometer:</div>-->
<!--      <div class="text-right" style="width: 150px; font-size: 16px">{{ travelExpenses.price }} €-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="d-flex justify-content-end">-->
<!--      <div style="width: 160px; font-size: 16px">Auszahlungsbetrag:</div>-->
<!--      <div class="text-right" style="width: 150px; font-size: 16px">{{ travelExpenses.total }} €-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script setup>
import CreateButton from '@/components/CreateButton.vue';
import {CloseToast} from '@/components/VueToast';
import {defineEmits, defineProps, ref, toRefs} from 'vue';

const emit = defineEmits(['getItemData', 'deleteItem', 'submitForApproval']);
const itemData = ref({});

const props = defineProps({
  travelExpenses: {
    type: Object,
    required: false,
  },
  items: {
    type: Array,
    required: false,
  }
});

const {travelExpenses, items} = toRefs(props);

function getItemData(item) {
  itemData.value = {...item};
  emit('getItemData', itemData.value);
}

function deleteItem(id) {
  CloseToast();
  emit('deleteItem', id);
}

function submitForApproval() {
  CloseToast();
  emit('submitForApproval');
}

</script>

<style scoped>

</style>